


import React, { useEffect, useState } from 'react';
import { CONFIG } from 'config/config';
import { isMobile } from 'react-device-detect';
import { Text, View } from '@coinscrap/webapp-core';

import TooltipSimple from 'components/TooltipSimple/TooltipSimple';

import arrowRigth from 'assets/images/svgStatic/arrowRigth.svg';

import * as S from './styles';

export const BeneficiaryOptions = ({ beneficiaryType, setBeneficiaryType }) => {
	const [options, setOptions] = useState([
		{
			id: 'generico',
			title: 'Herederos legales',
			desciption: 'El capital se destinará a los herederos legales.',
			tooltip: {
				title: 'Herederos legales',
				desciption:
					'En defecto de designación expresa será beneficiario por orden preferente y excluyente:',
				options: [
					{
						id: 1,
						title:
							'Cónyuge no separado legalmente por resolución judicial del asegurado.',
					},
					{
						id: 2,
						title: 'Hijos supervivientes del asegurado a partes iguales.',
					},
					{
						id: 3,
						title: 'Padres supervivientes del asegurado a partes iguales.',
					},
					{
						id: 4,
						title: 'Herederos legales del asegurado.',
					},
				],
			},
			selected: false,
		},
		{
			id: 'expreso',
			title: 'Libre designación',
			desciption: 'Nombra e identifica a la/s persona/s que tú elijas.',
			tooltip: false,
			selected: false,
		},
		{
			id: 'otros',
			title: 'Otros',
			desciption: 'A tu banco o a quién tú quieras con solo nominarlo.',
			tooltip: false,
			selected: false,
		},
	]);

	useEffect(() => {
		const newOptions = options.map((option) => {
			if (option.id === beneficiaryType) {
				return {
					...option,
					selected: true,
				};
			}
			return {
				...option,
				selected: false,
			};
		});
		setOptions(newOptions);
		/* eslint-disable-next-line */
	}, [beneficiaryType]);

	return (
		<>
			<Text style={{ color: CONFIG.colors.grey, paddingBottom: 20 }}>
				Añadir beneficiario
			</Text>
			<View gap2St>
				{options.map((option) => (
					<View key={option.id} coverageHeadMobileSt>
						<View
							displayGridSt
							gridCols3St
							gap4St
							onClick={() => setBeneficiaryType(option.id)}
						>
							<View colSpan2St rowSt justifyStartSt alignItemsCenterSt gap2St>
								<S.RadioButton selected={option.selected}>
									<S.RadioButtonInt selected={option.selected} />
								</S.RadioButton>
								<Text coverageMobileHeaderSt>{option.title}</Text>
							</View>
							<View>
								{option.tooltip && (
									<View rowSt justifyEndSt alignItemsCenterSt gap2St>
										<TooltipSimple>
											<View gap4St>
												<View gap2St>
													<Text
														style={{
															fontSize: CONFIG.fontSizes.lg,
															color: CONFIG.colors.primary,
														}}
													>
														{option.tooltip.title}
													</Text>
													<Text style={{ fontSize: CONFIG.fontSizes.md }}>
														{option.tooltip.desciption}
													</Text>
												</View>
												<View gap2St>
													{option.tooltip.options.map((option) => (
														<View
															key={option.id}
															rowSt
															gap2St
															justifyStartSt
															alignItemsStartSt
														>
															<S.StepCircle>
																<img
																	src={arrowRigth}
																	alt={'arrow icon'}
																/>
															</S.StepCircle>
															<Text>{option.title}</Text>
														</View>
													))}
												</View>
											</View>
										</TooltipSimple>
									</View>
								)}
							</View>
						</View>
						<View
							alignItemsStartSt
							style={{ paddingTop: '10px', paddingLeft: isMobile ? '0' : '33px' }}
						>
							<Text>{option.desciption}</Text>
						</View>
					</View>
				))}
			</View>
		</>
	);
};
